<!-- crm电子消费品行业解决方案模块 -->

<template>
  <div class="crmElec_solution_box">
      <div class="sheets_box">
        <div
          class="sheet_content"
          :style="{
            'background-image': 'url(' + bgData + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            width: '1344px',
            height: '766px',
          }"
          :class="{ title_en: $i18n.locale === 'en_US',title_ja:$i18n.locale === 'ja_JP' }"
        >
          <!-- 标题行 -->
          <div class="text_title title_height display_center" style="width:124px;top: 3.2rem; left: 0rem;">{{ $t("solution_crm.e-consumer.solutions.card.tab01.title") }}</div>
          <div class="text_title title_height display_center" style="width:1050px;top: 1.5rem; left: 14.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab02.title") }}</div>
          <div class="text_title title_height display_center" style="width:124px;top: 1.5rem; right: 0rem">{{ $t("solution_crm.e-consumer.solutions.card.tab14.title") }}</div>
          <div class="text_title title_height display_center" style="width:720px;top: 16rem; left: 14.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab03.title") }}</div>
          <div class="text_title title_height display_center" style="width:145px;top: 16rem; left: 88.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab07.title") }}</div>
          <div class="text_title title_height display_center" style="width:145px;top: 16rem; left: 105rem">{{ $t("solution_crm.e-consumer.solutions.card.tab08.title") }}</div>
          <div class="text_title title_height display_center" style="width:220px;top: 30.2rem; left: 14.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab04.title") }}</div>
          <div class="text_title title_height display_center" style="width:240px;top: 30.2rem; left: 38.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab05.title") }}</div>
          <div class="text_title title_height display_center" style="width:220px;top: 30.2rem; left: 64.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab06.title") }}</div>
          <div class="text_title title_height display_center" style="width:212px;top: 51rem; left: 14.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab10.title") }}</div>
          <div class="text_title title_height display_center" style="width:110px;top: 51rem; left: 38rem">{{ $t("solution_crm.e-consumer.solutions.card.tab11.title") }}</div>
          <div class="text_title title_height display_center" style="width:215px;top: 51rem; left: 50.8rem">{{ $t("solution_crm.e-consumer.solutions.card.tab12.title") }}</div>
          <div class="text_title title_height display_center" style="width:215px;top: 51rem; left: 74rem">{{ $t("solution_crm.e-consumer.solutions.card.tab13.title") }}</div>
          <div class="text_title title_height display_center" style="width:220px;top: 51rem; left: 97.5rem">{{ $t("solution_crm.e-consumer.solutions.card.tab09.title") }}</div>

          <!-- 倒数第一行 白字 -->
        <div class="text_white bottom_text display_dir_row">
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.e-consumer.solutions.card.tab15.title1") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.e-consumer.solutions.card.tab15.title2") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.e-consumer.solutions.card.tab15.title3") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.e-consumer.solutions.card.tab15.title4") }}
          </div>
        </div>

          <!-- 第一列 渠道门户部分 -->
          <div class="text_normal text_normal1_1" style="top: 11rem; left: 4.8rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text1") }}</div>
          <div class="text_normal text_normal1" style="top: 20rem; left: 4.8rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text2") }}</div>
          <div class="text_normal text_normal1" style="top: 30.5rem; left: 4.8rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text3") }}</div>
          <div class="text_normal text_normal1 text_normal1_1_ja" style="top: 40.5rem; left: 4.8rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text4") }}</div>
          <div class="text_normal text_normal1 text_normal1_2_ja" style="top: 52rem; left: 4.8rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text5") }}</div>
          <div class="text_normal text_normal1_2" style="top: 61rem; left: 3rem;width: 7rem; text-align: center;" >{{ $t("solution_crm.e-consumer.solutions.card.tab01.desc.text6") }}</div>

          <!-- 第二列 第一行 决策分析部分-->
          <div class="text_normal" style="top: 6.9rem; left: 19.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text1") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 34.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text2") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 49rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text3") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 64.1rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text4") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 79rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text5") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 93.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text6") }}
          </div>
          <div class="text_normal" style="top: 6.9rem; left: 108.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab02.desc.text7") }}
          </div>
          
          <!-- 第二列 第二行 运营管理部分-->
          <div class="text_normal text_normal2_1" style="top: 21.4rem; left: 21rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab03.desc.text1") }}
          </div>
          <div class="text_normal" style="top: 21.4rem; left: 37.7rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab03.desc.text2") }}
          </div>
          <div class="text_normal text_normal2_2" style="top: 21.4rem; left: 56.2rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab03.desc.text3") }}
          </div>
          <div class="text_normal text_normal2 text_normal2_1_ja" style="top: 21.4rem; left: 73.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab03.desc.text4") }}
          </div>
          <!-- 第二列  第三、四行  市场管理、销售管理、BP计划管理-->
          <div class="text_normal text_normal3_1 text_normal3_1_ja" style="top: 35.8rem; left: 17.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab04.desc.text1") }}
          </div>
          <div class="text_normal text_normal3_2" style="top: 35.8rem; left: 27.7rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab04.desc.text2") }}
          </div>
          <div class="text_normal text_normal3_3" style="top: 42.2rem; left: 17.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab04.desc.text3") }}
          </div>
          <div class="text_normal text_normal3_2 text_normal3_2_ja" style="top: 42.2rem; left: 27.7rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab04.desc.text4") }}
          </div>

          <div class="text_normal text_normal4_1" style="top: 35.8rem; left: 42rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab05.desc.text1") }}
          </div>
          <div class="text_normal text_normal4_2 text_normal4_1_ja" style="top: 35.8rem; left: 52.4rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab05.desc.text2") }}
          </div>
          <div class="text_normal text_normal4_1" style="top: 42.2rem; left: 42rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab05.desc.text3") }}
          </div>
          <div class="text_normal text_normal4_3 text_normal4_2_ja" style="top: 42.2rem; left: 53.2rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab05.desc.text4") }}
          </div>

          <div class="text_normal text_normal5_1" style="top: 35.8rem; left: 68rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab06.desc.text1") }}
          </div>
          <div class="text_normal text_normal5_2 text_normal5_1_ja" style="top: 35.8rem; left: 78.6rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab06.desc.text2") }}
          </div>
          <div class="text_normal text_normal5_3 text_normal5_2_ja" style="top: 42.2rem; left: 68rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab06.desc.text3") }}
          </div>
          <div class="text_normal text_normal5_2 text_normal5_3_ja" style="top: 42.2rem; left: 78rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab06.desc.text4") }}
          </div>
          <!-- 合同订单管理、渠道管理 -->
          <div class="text_normal text_normal5_4" style="top: 21.5rem; left: 92.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab07.desc.text1") }}
          </div>
          <div class="text_normal text_normal5_4" style="top: 28.5rem; left: 92.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab07.desc.text2") }}
          </div>
          <div class="text_normal text_normal5_4" style="top: 35.2rem; left: 92.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab07.desc.text3") }}
          </div>
          <div class="text_normal text_normal5_4" style="top: 42rem; left: 92.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab07.desc.text4") }}
          </div>

          <div class="text_normal text_normal6_1 text_normal6_1_ja" style="top: 21.5rem; left: 108.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab08.desc.text1") }}
          </div>
          <div class="text_normal text_normal6_2" style="top: 28.5rem; left: 109.1rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab08.desc.text2") }}
          </div>
          <div class="text_normal text_normal6_2 text_normal6_2_ja" style="top: 35.2rem; left: 109.1rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab08.desc.text3") }}
          </div>
          <div class="text_normal text_normal6_2" style="top: 42rem; left: 109.1rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab08.desc.text4") }}
          </div>

          <!-- 第二列 第五六行 客户管理、竞争对手、产品管理、用户/权限、服务管理 -->
          <div class="text_normal text_normal7_1 text_normal7_ja" style="top: 56.6rem; left: 17.3rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab10.desc.text1") }}
          </div>
          <div class="text_normal text_normal7_2" style="top: 56.6rem; left: 28rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab10.desc.text2") }}
          </div>
          <div class="text_normal text_normal7_1" style="top: 63rem; left: 17.3rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab10.desc.text3") }}
          </div>
          <div class="text_normal text_normal7_2" style="top: 63rem; left: 27.2rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab10.desc.text4") }}
          </div>

          <div class="text_normal text_normal8_1" style="top: 56.6rem; left: 40.3rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab11.desc.text1") }}
          </div>
          <div class="text_normal text_normal8_2 text_normal8_1_ja" style="top: 63rem; left: 40.3rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab11.desc.text2") }}
          </div>

          <div class="text_normal text_normal8_3 text_normal8_2_ja" style="top: 56.6rem; left: 53.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab12.desc.text1") }}
          </div>
          <div class="text_normal text_normal8_4 text_normal8_3_ja" style="top: 56.6rem; left: 63.4rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab12.desc.text2") }}
          </div>
          <div class="text_normal text_normal8_3" style="top: 63rem; left: 53.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab12.desc.text3") }}
          </div>
          <div class="text_normal text_normal8_4 text_normal8_4_ja" style="top: 63rem; left: 63.4rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab12.desc.text4") }}
          </div>

          <div class="text_normal text_normal9_1 text_normal9_1_ja" style="top: 56.6rem; left: 76.7rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab13.desc.text1") }}
          </div>
          <div class="text_normal text_normal9_2" style="top: 56.6rem; left: 86.6rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab13.desc.text2") }}
          </div>
          <div class="text_normal text_normal9_1" style="top: 63rem; left: 76.7rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab13.desc.text3") }}
          </div>
          <div class="text_normal text_normal9_3 text_normal9_2_ja" style="top: 63rem; left: 86.6rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab13.desc.text4") }}
          </div>

          <div class="text_normal text_normal10_1 text_normal10_1_ja" style="top: 56.6rem; left: 100.2rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab09.desc.text1") }}
          </div>
          <div class="text_normal text_normal10_2 text_normal10_2_ja" style="top: 56.6rem; left: 110.5rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab09.desc.text2") }}
          </div>
          <div class="text_normal text_normal10_3 text_normal10_3_ja" style="top: 63rem; left: 100.2rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab09.desc.text3") }}
          </div>
          <div class="text_normal text_normal10_2" style="top: 63rem; left: 109.8rem">
            {{ $t("solution_crm.e-consumer.solutions.card.tab09.desc.text4") }}
          </div>
          
          <!-- 最后一列 移动端 -->
          <div class="text_normal text_normal11 text_normal11_1_ja" style="top: 6.7rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text1") }}</div>
          <div class="text_normal text_normal11_1" style="top: 14.6rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text2") }}</div>
          <div class="text_normal text_normal11" style="top: 22.6rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text3") }}</div>
          <div class="text_normal text_normal11_2" style="top: 30.5rem; left: 125.5rem;width: 5rem; text-align: center;" >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text4") }}</div>
          <div class="text_normal text_normal11" style="top: 38.5rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text5") }}</div>
          <div class="text_normal text_normal11" style="top: 47.5rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text6") }}</div>
          <div class="text_normal text_normal11 text_normal11_2_ja" style="top: 53.9rem; left: 126.3rem;width: 4rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text7") }}</div>
          <div class="text_normal text_normal11_3 text_normal11_3_ja" style="top: 62.8rem; left: 125.5rem;width: 5rem; " >{{ $t("solution_crm.e-consumer.solutions.card.tab14.desc.text8") }}</div>
          
          

          
          

         
          
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>

export default {
  name: 'crmElecConsumeSolution',
  data () {
    return {
      bgData: require('@/assets/images/IndustrySolution/crm/elecConsume/crm_elec_solution_bg.png'),
    }

  }
}
</script>